export default __webpack_public_path__ + "static/media/login_image.ea4a0930.jpg";